export default "__VITE_ASSET__c65f490e__"